export function createSection<T>(title: string, attrName: keyof T) {
  return {title, attrName};
}
